import { MaskLine, Eyebrow } from "./Motion";

export const PageHeader = ({ eyebrow, lines, intro, testid }) => (
  <section data-testid={testid} className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 pt-36 sm:pt-44 pb-14 grid lg:grid-cols-12 gap-8 items-end">
    <div className="lg:col-span-8">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="mt-6 font-serif text-5xl sm:text-7xl lg:text-[7rem] leading-[0.95] tracking-tight text-ink">
        {lines.map((l, i) => (
          <MaskLine key={i} delay={0.15 + i * 0.12} className={i === lines.length - 1 ? "italic text-cypress" : ""}>{l}</MaskLine>
        ))}
      </h1>
    </div>
    {intro && <p className="lg:col-span-4 text-base sm:text-lg text-ink/75 leading-relaxed">{intro}</p>}
  </section>
);
